/**
 * Iniciais de um nome para avatar: a 1ª letra das DUAS primeiras palavras que começam com letra
 * ou número. #608: "Marina - IA" virava "M-" porque o hífen contava como palavra. Sem palavra
 * válida, "?".
 */
export function iniciais(nome: string): string {
  const palavras = nome.trim().split(/\s+/).filter((p) => /^[\p{L}\p{N}]/u.test(p));
  return palavras.slice(0, 2).map((p) => p[0]!.toUpperCase()).join('') || '?';
}
